export const siteInfo = {
  name: '番茄视频',
  slogan: '全网免费影视聚合平台',
  tagline: '全网免费·高清不缓冲',
};

export const navItems = [
  { label: '首页', href: '#hero' },
  { label: '焦点推荐', href: '#carousel' },
  { label: '热门榜单', href: '#ranking' },
  { label: '话题热榜', href: '#topics' },
  { label: '平台特色', href: '#features' },
  { label: '关于番茄', href: '#about' },
];

export const heroStats = [
  { value: '200+', label: '每日更新影片' },
  { value: '10万+', label: '影视资源覆盖' },
  { value: '1080P', label: '高清流畅播放' },
];

export const faqItems = [
  {
    question: '番茄视频真的完全免费吗？',
    answer: '是的，番茄视频所有内容均免费提供，无需任何付费或会员订阅。我们聚合西瓜视频免费、91在线视频、小蓝视频、久久视频等多平台优质资源，让您畅享免费高清影视盛宴。',
  },
  {
    question: '播放视频需要下载APP吗？',
    answer: '不需要。番茄视频支持网页端直接播放，即点即看无需安装。无论您使用电脑、平板还是手机浏览器，都能流畅在线观看。',
  },
  {
    question: '视频画质和缓冲情况怎么样？',
    answer: '我们提供高清画质，大部分资源支持1080P清晰度在线播放。采用智能CDN加速技术，确保即点即播不缓冲，给您流畅的观影体验。',
  },
  {
    question: '内容多久更新一次？',
    answer: '每日定时更新，热门剧集上线后2小时内同步上架。涵盖电影、电视剧、综艺、动漫等全品类内容，让您第一时间追到最新剧集。',
  },
];

export const carouselItems = [
  {
    title: '热播剧集专场',
    description: '全网热播大剧一网打尽，每日同步更新最新剧集',
    tag: '追剧必看',
    imageUrl: 'https://readdy.ai/api/search-image?query=Warm%20cinematic%20scene%20of%20a%20living%20room%20with%20large%20TV%20screen%20displaying%20dramatic%20movie%20scene%2C%20cozy%20atmosphere%20with%20warm%20ambient%20lighting%2C%20modern%20interior%2C%20soft%20shadows%2C%20cinematic%20color%20grading%20with%20warm%20orange%20and%20amber%20tones%2C%20professional%20photography%2C%20no%20text%20or%20watermarks&width=800&height=500&seq=carousel-01-2026&orientation=landscape',
  },
  {
    title: '最新院线大片',
    description: '院线热映大片高清上线，足不出户享受影院级体验',
    tag: '新片速递',
    imageUrl: 'https://readdy.ai/api/search-image?query=Home%20theater%20setup%20with%20projector%20screen%20showing%20cinematic%20imagery%2C%20dark%20room%20with%20warm%20accent%20lighting%2C%20comfortable%20seating%2C%20premium%20audio%20equipment%2C%20atmospheric%20mood%2C%20rich%20dark%20tones%20with%20warm%20highlights%2C%20professional%20interior%20photography&width=800&height=500&seq=carousel-02-2026&orientation=landscape',
  },
  {
    title: '经典怀旧剧场',
    description: '重温经典老剧，找回青春记忆中的感动瞬间',
    tag: '经典重温',
    imageUrl: 'https://readdy.ai/api/search-image?query=Vintage%20film%20projector%20with%20warm%20glowing%20light%20beam%2C%20old%20movie%20posters%20on%20brick%20wall%20background%2C%20nostalgic%20cinema%20aesthetic%2C%20warm%20sepia%20and%20golden%20tones%2C%20soft%20atmospheric%20lighting%2C%20retro%20theater%20vibe%2C%20artistic%20composition&width=800&height=500&seq=carousel-03-2026&orientation=landscape',
  },
  {
    title: '综艺爆笑合集',
    description: '热门综艺全程高能，爆笑名场面一次看过瘾',
    tag: '欢乐不断',
    imageUrl: 'https://readdy.ai/api/search-image?query=Bright%20and%20colorful%20TV%20studio%20set%20with%20warm%20stage%20lighting%2C%20entertainment%20show%20atmosphere%2C%20vibrant%20decor%20with%20red%20and%20gold%20accents%2C%20professional%20broadcast%20studio%20photography%2C%20energetic%20mood%2C%20warm%20spotlights%20on%20stage&width=800&height=500&seq=carousel-04-2026&orientation=landscape',
  },
  {
    title: '热门动漫连载',
    description: '人气动漫同步更新，日漫国漫全收录随你挑',
    tag: '二次元',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20of%20a%20cozy%20viewing%20room%20with%20warm%20lighting%2C%20colorful%20anime%20posters%20on%20walls%2C%20comfortable%20bean%20bags%2C%20warm%20orange%20and%20pink%20color%20palette%2C%20soft%20atmospheric%20glow%2C%20modern%20anime%20merchandise%20display%2C%20inviting%20mood&width=800&height=500&seq=carousel-05-2026&orientation=landscape',
  },
];

export const cardItems = [
  {
    title: '电影大全',
    description: '动作、喜剧、爱情、科幻等全类型覆盖，热门新片与经典佳作随时在线播放。',
    icon: 'ri-film-line',
    tag: '热',
    imageUrl: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20scene%20collage%20with%20warm%20lighting%2C%20film%20strips%20and%20clapperboard%20on%20dark%20wooden%20surface%2C%20dramatic%20atmosphere%2C%20rich%20amber%20and%20gold%20tones%2C%20elegant%20product%20photography%2C%20soft%20shadows&width=600&height=400&seq=cards-01-2026&orientation=landscape',
  },
  {
    title: '电视剧库',
    description: '国产剧、韩剧、美剧、日剧全覆盖，热门剧集与经典老剧随时畅享。',
    icon: 'ri-tv-line',
    tag: '新',
    imageUrl: 'https://readdy.ai/api/search-image?query=Modern%20living%20room%20with%20large%20flat%20screen%20TV%20mounted%20on%20wall%20displaying%20drama%20series%2C%20warm%20cozy%20interior%20with%20soft%20lamps%2C%20comfortable%20sofa%2C%20evening%20atmosphere%2C%20warm%20orange%20ambient%20light&width=600&height=400&seq=cards-02-2026&orientation=landscape',
  },
  {
    title: '综艺娱乐',
    description: '热门综艺一网打尽，搞笑、音乐、真人秀随时随地欢乐不停。',
    icon: 'ri-emotion-laugh-line',
    tag: '爆',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20TV%20variety%20show%20stage%20with%20warm%20studio%20lighting%2C%20bright%20decorative%20elements%2C%20entertainment%20atmosphere%2C%20confetti%20and%20sparkles%2C%20vibrant%20red%20and%20gold%20color%20scheme%2C%20professional%20stage%20photography&width=600&height=400&seq=cards-03-2026&orientation=landscape',
  },
  {
    title: '动漫频道',
    description: '日漫国漫同步更新，热血、治愈、奇幻等多元题材任你挑选。',
    icon: 'ri-ghost-line',
    tag: '更',
    imageUrl: 'https://readdy.ai/api/search-image?query=Anime%20art%20style%20desk%20setup%20with%20warm%20desk%20lamp%20lighting%2C%20colorful%20manga%20volumes%20stacked%2C%20anime%20figures%20displayed%2C%20cozy%20room%20corner%2C%20soft%20warm%20glow%2C%20pink%20and%20orange%20pastel%20tones&width=600&height=400&seq=cards-04-2026&orientation=landscape',
  },
  {
    title: '纪录片专区',
    description: '自然、历史、科技、人文纪录片，拓展视野感受真实世界之美。',
    icon: 'ri-earth-line',
    tag: '荐',
    imageUrl: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20scene%20of%20golden%20sunset%20over%20vast%20landscape%2C%20warm%20earthy%20tones%2C%20cinematic%20aerial%20photography%2C%20dramatic%20clouds%20with%20golden%20hour%20lighting%2C%20beautiful%20natural%20scenery%2C%20professional%20wildlife%20photography%20style&width=600&height=400&seq=cards-05-2026&orientation=landscape',
  },
];

export const topicItems = [
  { name: '热播剧集', heat: '98万', hot: true },
  { name: '古装仙侠', heat: '76万', hot: true },
  { name: '悬疑推理', heat: '65万', hot: true },
  { name: '都市情感', heat: '58万', hot: false },
  { name: '科幻巨制', heat: '52万', hot: false },
  { name: '韩剧精选', heat: '47万', hot: true },
  { name: '国产动漫', heat: '43万', hot: false },
  { name: '喜剧之王', heat: '39万', hot: false },
  { name: '战争史诗', heat: '35万', hot: false },
  { name: '恐怖惊悚', heat: '31万', hot: false },
  { name: '纪录片', heat: '28万', hot: false },
];

export const rankingItems = [
  { rank: 1, title: '繁花', desc: '胡歌主演年代大剧，再现上海滩风云', tag: '热播', change: 'up' },
  { rank: 2, title: '狂飙', desc: '张译张颂文飙戏，扫黑风暴震撼人心', tag: '经典', change: 'same' },
  { rank: 3, title: '庆余年第二季', desc: '张若昀回归，权谋江湖再起波澜', tag: '新剧', change: 'up' },
  { rank: 4, title: '三体', desc: '刘慈欣科幻巨制，宇宙奥秘震撼呈现', tag: '热播', change: 'down' },
  { rank: 5, title: '与凤行', desc: '赵丽颖林更新再续前缘，仙侠传奇', tag: '新剧', change: 'up' },
  { rank: 6, title: '莲花楼', desc: '成毅演绎江湖奇案，古装悬疑力作', tag: '推荐', change: 'up' },
  { rank: 7, title: '长相思', desc: '杨紫主演神话大剧，三界情缘动人', tag: '热播', change: 'same' },
];

export const appItem = {
  title: '随时随地，畅享高清影视',
  description: '番茄视频移动端适配完美，手机浏览器直接访问，无需下载安装。横屏竖屏自由切换，地铁通勤、午休时间随时追剧。流量优化模式省流50%，WiFi下自动高清播放，让观影从未如此自由。',
  features: ['无需安装即开即看', '流量优化省流50%', '横竖屏自由切换', '1080P高清流畅'],
};

export const indexItems = [
  { title: '年代剧精选', count: '328部', desc: '穿越时光的经典故事' },
  { title: '武侠江湖', count: '215部', desc: '刀光剑影中的侠义情怀' },
  { title: '都市爱情', count: '467部', desc: '现代都市里的心动瞬间' },
  { title: '谍战风云', count: '189部', desc: '隐蔽战线上的智慧较量' },
  { title: '家庭伦理', count: '276部', desc: '平凡生活中的温暖真情' },
  { title: '青春校园', count: '198部', desc: '最美年华里的成长故事' },
  { title: '历史正剧', count: '156部', desc: '恢弘史诗中的家国天下' },
  { title: '奇幻冒险', count: '234部', desc: '想象力的无限可能' },
];

export const commentItems = [
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Chinese%20woman%20with%20warm%20smile%2C%20soft%20studio%20lighting%2C%20clean%20cream%20background%2C%20natural%20makeup%2C%20professional%20headshot%20photography&width=80&height=80&seq=avatar-01&orientation=squarish',
    name: '星辰大海',
    time: '2小时前',
    content: '用了番茄视频快半年了，真的良心！每天都有新剧更新，高清不卡顿，推荐给了好多朋友。西瓜视频和91在线的资源都能在这找到，太方便了。',
    likes: 1286,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20man%20in%20casual%20style%2C%20warm%20friendly%20expression%2C%20soft%20studio%20lighting%2C%20neutral%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-02&orientation=squarish',
    name: '追剧达人',
    time: '5小时前',
    content: '繁花在这里看的，画质绝了！小蓝视频和久久视频的资源也很全，以前要到处找资源，现在一个番茄就够了。即点即播确实不缓冲，体验超棒。',
    likes: 967,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20young%20Chinese%20woman%20with%20glasses%2C%20intellectual%20look%2C%20warm%20lighting%2C%20cream%20background%2C%20professional%20headshot%20photography&width=80&height=80&seq=avatar-03&orientation=squarish',
    name: '电影控小雨',
    time: '8小时前',
    content: '纪录片频道太惊喜了！BBC和国家地理的资源都有，周末一口气看了三部自然纪录片，高清画质配大屏简直享受。关键是完全免费在线播放。',
    likes: 753,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20man%20smiling%20warmly%2C%20business%20casual%20style%2C%20soft%20lighting%2C%20clean%20background%2C%20professional%20headshot%20photography&width=80&height=80&seq=avatar-04&orientation=squarish',
    name: '深夜刷剧人',
    time: '12小时前',
    content: '通勤路上全靠番茄视频续命！流量优化做得不错，地铁上用流量看也不卡。91视频网站的悬疑片资源特别全，推理迷狂喜。',
    likes: 621,
  },
  {
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20portrait%20of%20Chinese%20woman%20with%20warm%20genuine%20smile%2C%20casual%20style%2C%20soft%20natural%20lighting%2C%20cream%20background%2C%20professional%20headshot&width=80&height=80&seq=avatar-05&orientation=squarish',
    name: '剧荒拯救者',
    time: '1天前',
    content: '免费在线观看真的不是噱头，用了这么久没花一分钱。热门榜单很准，跟着榜单追了几部剧都很好看，更新速度也快。推荐给所有剧荒的朋友！',
    likes: 1492,
  },
];

export const mediaItems = [
  {
    title: '热门电影：封神第二部',
    duration: '02:18:45',
    views: '385万',
    tag: '热映',
    imageUrl: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20mythological%20film%20scene%20with%20golden%20warriors%20and%20dragons%2C%20dramatic%20lighting%2C%20warm%20orange%20and%20gold%20tones%2C%20cinematic%20composition%2C%20ancient%20Chinese%20aesthetic%2C%20grand%20scale%20battle%20scene&width=640&height=360&seq=media-01-2026&orientation=landscape',
  },
  {
    title: '高分韩剧：眼泪女王',
    duration: '01:05:30',
    views: '267万',
    tag: '热播',
    imageUrl: 'https://readdy.ai/api/search-image?query=Romantic%20Korean%20drama%20scene%20with%20elegant%20couple%20in%20warm%20lighting%2C%20beautiful%20urban%20night%20setting%2C%20soft%20golden%20glow%2C%20emotional%20atmosphere%2C%20cinematic%20Korean%20drama%20aesthetic%2C%20warm%20amber%20tones&width=640&height=360&seq=media-02-2026&orientation=landscape',
  },
  {
    title: '热门动漫：完美世界',
    duration: '00:22:10',
    views: '198万',
    tag: '更新',
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20animation%20fantasy%20scene%20with%20martial%20arts%20characters%20in%20ancient%20Chinese%20setting%2C%20dynamic%20action%20pose%2C%20warm%20glowing%20energy%20effects%2C%20golden%20and%20orange%20color%20scheme%2C%20epic%20atmosphere&width=640&height=360&seq=media-03-2026&orientation=landscape',
  },
  {
    title: '热播综艺：奔跑吧',
    duration: '01:32:00',
    views: '456万',
    tag: '热门',
    imageUrl: 'https://readdy.ai/api/search-image?query=Colorful%20outdoor%20variety%20show%20scene%20with%20warm%20sunlight%2C%20group%20of%20people%20playing%20games%20in%20park%2C%20energetic%20atmosphere%2C%20bright%20vibrant%20colors%20with%20warm%20tones%2C%20professional%20broadcast%20photography&width=640&height=360&seq=media-04-2026&orientation=landscape',
  },
  {
    title: '纪录大片：地球脉动3',
    duration: '00:58:20',
    views: '156万',
    tag: '高分',
    imageUrl: 'https://readdy.ai/api/search-image?query=Stunning%20nature%20documentary%20scene%20of%20golden%20sunset%20over%20savanna%20with%20wildlife%20silhouettes%2C%20warm%20dramatic%20sky%2C%20cinematic%20aerial%20photography%2C%20rich%20orange%20and%20amber%20tones%2C%20breathtaking%20natural%20beauty&width=640&height=360&seq=media-05-2026&orientation=landscape',
  },
];

export const contactItem = {
  title: '商务合作 / 内容投稿',
  description: '欢迎优质内容创作者、版权方及广告合作伙伴联系我们。番茄视频致力于打造开放共赢的影视内容生态，期待与您携手共创精彩。',
  email: 'contact@fanqie.video',
  wechat: 'fanqieshipin',
};

export const updateItems = [
  { date: '2026-07-31', title: '「繁花」全集高清上线', desc: '胡歌主演年度大剧繁花全集高清资源已上线番茄视频，即点即播免费在线观看。' },
  { date: '2026-07-30', title: '纪录片频道改版升级', desc: '纪录片专区全新改版，新增BBC、国家地理、Discovery等品牌纪录片资源超500部。' },
  { date: '2026-07-28', title: '动漫频道新增国漫专区', desc: '国产动漫独立专区上线，收录近三年热门国漫作品，支持1080P高清在线播放。' },
  { date: '2026-07-25', title: '播放器全面升级', desc: '全新播放引擎上线，加载速度提升40%，支持智能画质切换与断点续播功能。' },
  { date: '2026-07-22', title: '韩剧频道资源扩充', desc: '新增100+部高分韩剧资源，91在线视频与久久视频热门韩剧同步收录，免费在线观看。' },
  { date: '2026-07-20', title: '移动端观影体验优化', desc: '手机浏览器适配全面升级，横竖屏切换更流畅，流量模式下画质与省流平衡更出色。' },
  { date: '2026-07-18', title: '番茄视频正式上线运营', desc: '整合西瓜视频免费、小蓝视频等多平台资源，一站式免费影视聚合平台正式与大家见面。' },
];

export const aboutItem = {
  title: '关于番茄视频',
  content: '番茄视频是一个综合性的免费影视聚合平台，致力于为广大影迷提供一站式高清观影体验。我们汇集了西瓜视频免费、91在线视频、小蓝视频、久久视频等多个平台的优质影视资源，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。\n\n我们的使命是让每个人都能轻松享受高清影视内容，无需付费、无需繁琐注册，即点即播不缓冲。平台每日更新最新剧集，热门内容上线后2小时内同步，确保您不错过任何精彩。\n\n无论您是热衷追剧的影视达人，还是偶尔放松的休闲观众，番茄视频都以丰富的资源库、流畅的播放体验和简洁易用的界面，成为您值得信赖的免费在线观看平台。',
  stats: [
    { value: '10万+', label: '影视资源' },
    { value: '日均200+', label: '更新内容' },
    { value: '500万+', label: '月活用户' },
    { value: '99.9%', label: '播放成功率' },
  ],
};

export const featureItems = [
  {
    icon: 'ri-flashlight-line',
    title: '即点即播不缓冲',
    description: '智能CDN加速，多节点分发，确保高清视频即点即播、流畅不卡顿，告别等待和缓冲。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '全免费不收费',
    description: '所有视频内容永久免费在线观看，无需会员订阅，无需付费解锁，真正零门槛畅享影视盛宴。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端无缝切换',
    description: '电脑、平板、手机全平台适配，横竖屏自由切换，随时随地在线播放高清视频。',
  },
];